import { CHAPTERS, FIRM } from "@/lib/site";
import { MaskReveal, FadeUp } from "./Reveal";
import { motion } from "framer-motion";

const OFFICE_IMG =
  "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 md:py-36">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="overline text-[#B8962E] mb-6">/ 14 Years of Practice</div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <MaskReveal as="h2"
            className="font-serif-display text-[#0A1128] text-4xl md:text-5xl lg:text-6xl leading-[1.02] mb-10"
            lines={["A practice built", "on rigour and", "quiet authority."]} />

          <div className="divide-y divide-[#E5E7EB] border-t border-[#E5E7EB]">
            {CHAPTERS.map((c, i) => (
              <FadeUp key={c.n} delay={i * 0.08}>
                <div className="py-6 flex gap-6 group">
                  <span className="font-mono-meta text-[#D4AF37] text-sm pt-1">{c.n}</span>
                  <div>
                    <h3 className="font-serif-display text-2xl text-[#0A1128] mb-1">{c.title}</h3>
                    <p className="font-body text-[#4b5563] text-sm leading-relaxed max-w-sm">{c.desc}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <FadeUp>
            <div className="relative overflow-hidden border border-[#E5E7EB]">
              <motion.img
                initial={{ scale: 1.12 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
                transition={{ duration: 1.6, ease: [0.33, 1, 0.68, 1] }}
                src={OFFICE_IMG} alt="Law office interior"
                className="w-full h-[420px] md:h-[640px] object-cover" />
              <div className="absolute bottom-0 left-0 right-0 bg-[#0A1128] p-6 md:p-8 flex flex-wrap gap-8">
                <div>
                  <div className="font-serif-display text-4xl text-[#D4AF37]">{FIRM.experience}+</div>
                  <div className="overline text-white/60 mt-1">Years</div>
                </div>
                <div>
                  <div className="font-serif-display text-4xl text-[#D4AF37]">16</div>
                  <div className="overline text-white/60 mt-1">Practice Areas</div>
                </div>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </div>
  </section>
);
